import React, { useState } from 'react';
import { PenlySeo, Button, Spacer, ContentBoxContainer, ContentBoxText, ContentBoxFigure, Loader } from 'components';
import TextField from '@material-ui/core/TextField';
import { signupForThePenlyPanel } from 'api/neway';
import { awaitAtLeast } from 'utils/async';
import { useFormik } from 'formik';
import * as yup from 'yup';

const validationSchema = yup.object({
    name: yup
        .string('Indtast dit navn')
        .required('Navn er krævet'),
    email: yup
        .string()
        .email('Indtast en korrekt e-mailadresse')
        .required('E-mailadresse er krævet'),
    accepted: yup
        .boolean()
        .oneOf([true], 'Du skal acceptere at blive kontaktet for at være en del af Penly Panelet'),
});

const title = 'Penly Panelet - Hjælp os, og få samtidig meget mere styr på din pension.';
const image = { url: '/static/gfx/content/penly-content-2.jpg' };
const description = 'Deltag i Penly Panelet og få indflydelse på retningen af Penlys udvikling ';

export default function PenlypanelPage() {
    const [sent, setSent] = useState(false);

    const formik = useFormik({
        initialValues: { name: '', email: '', accepted: false },
        validationSchema,
        onSubmit: async ({ name, email }) => {
            await awaitAtLeast(1000, signupForThePenlyPanel, { name, email } );
            setSent(true);
            window.scrollTo(0, 0);
        },
    });

    return (
        <>
            <PenlySeo title={ title } description={ description } image={ image } />
            <ContentBoxContainer className="fluid">
                <ContentBoxText>
                    { ( formik.isSubmitting && <Loader show /> ) }
                    {
                        (!sent ? (
                            <>
                                <h1 className="nomb">
                                    Bliv en del af <span className="color-highlight">Penly Panelet</span>
                                </h1>
                                <h4 className="lowerCase">Hjælp os, og få samtidig meget mere styr på din pension.</h4>
                                <p>
                                    Penly er i rivende udvikling med vores løbende PensionsTjek hvor du helt gratis på under 5 minutter får et hurtigt
                                    overblik over dine pensionsordninger.
                                </p>
                                <p>
                                    Vi tilføjer løbende værdiskabende gratis features, samt features mod betaling. Til det har vi brug for din hjælp
                                    for at høre din mening om hvilke ekstra gratis features, der vil få dig til at bruge 5 minutter på Penly, samt hvilke
                                    features du ville betale for.
                                </p>
                                <p>
                                    Som tak for deltagelsen, får de første 100 tilmeldte til Penly Panelet, vores betalings features gratis i hele 2 år.
                                    Samtidig får du indflydelse på vores udviklings retning.
                                </p>
                                <p>
                                    Udfyld dit navn og e-mail adresse for at blive en del af Penly Panelet.
                                </p>

                                <form onSubmit={ formik.handleSubmit }>
                                    <div className="formgroups">
                                        <div className="formgroup">
                                            <TextField
                                                label="Dit navn"
                                                name="name"
                                                variant="filled"
                                                multiline
                                                value={ formik.values.name }
                                                onChange={ formik.handleChange }
                                                onBlur={ formik.handleBlur }
                                                error={ formik.touched.name && Boolean(formik.errors.name) }
                                                helperText={ formik.touched.name && formik.errors.name }
                                            />
                                        </div>
                                        <div className="formgroup">
                                            <TextField
                                                label="Din e-mail"
                                                name="email"
                                                variant="filled"
                                                multiline
                                                value={ formik.values.email }
                                                onChange={ formik.handleChange }
                                                onBlur={ formik.handleBlur }
                                                error={ formik.touched.email && Boolean(formik.errors.email) }
                                                helperText={ formik.touched.email && formik.errors.email }
                                            />
                                        </div>
                                    </div>
                                    <div className="formgroups">
                                        <div className="formgroup">
                                            <div className="checkbox" style={{ margin: 0 }}>
                                                <input
                                                    name="accepted"
                                                    id="accepted"
                                                    type='checkbox'
                                                    value={ formik.values.accepted }
                                                    onChange={ formik.handleChange }
                                                />
                                                <label htmlFor="accepted">
                                                    Jeg accepterer at blive kontaktet ift. deltagelse i Penly Panelet.
                                                    Jeg kan til enhver tid forlade panelet.
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    { formik.touched.accepted && (
                                        <p className="validationError">
                                            { formik.errors.accepted }
                                        </p>
                                    ) }
                                    <Spacer size="small" />
                                    <div>
                                        <Button type='submit'>Send tilmelding</Button>
                                    </div>
                                </form>
                            </>
                        ) : (
                            <>
                                <h2 className="nomb">Mange tak for din tilmelding til Penly Panelet!</h2>
                                <Spacer />
                            </>
                        ))
                    }
                </ContentBoxText>
                <ContentBoxFigure className="penlyEmoji" />
            </ContentBoxContainer>
        </>
    );
}
